export const PackageMaterialTypeMessages = {
  'en-US': {
    packageMaterialType: {
      Unknown: 'Unknown',
      Box: 'Box',
      BubbleMailer: 'Bubble Mailer',
      PolyMailer: 'Poly Mailer',
      FragileBox: 'FRAGILE - Box',
      PosterTube: 'Poster Tube',
      CustomPackaging: 'Custom Packaging',
      BookfoldLarge: 'Bookfold - Large',
      ShipInOwnContainer: 'Ship In Own Container'
    }
  }
}
